import { useState } from 'react';
import { useOperatorSignal } from '@entities/operator';
import '@features/test-chat';
import { OperatorsInbox } from './OperatorsInbox';
import { OperatorsSetup } from './OperatorsSetup';
import '../assistant-settings/settings.css';
import '../test-chat/test-chat.css';
import './operators.css';

const TAB_KEY = 'richat.operators.tab';
type Tab = 'inbox' | 'setup';

/**
 * Серия O: «Операторы» — запросы клиентов и настройка (решение Игоря 29.10).
 * Как тест-чат: на всю высоту окна, вкладки в тонкой верхней строке.
 */
export function OperatorsPage() {
  const [tab, setTabState] = useState<Tab>(() => {
    try {
      return window.localStorage.getItem(TAB_KEY) === 'setup' ? 'setup' : 'inbox';
    } catch {
      return 'inbox';
    }
  });
  const waiting = useOperatorSignal();
  const setTab = (t: Tab) => {
    setTabState(t);
    try {
      window.localStorage.setItem(TAB_KEY, t);
    } catch {
      /* без запоминания */
    }
  };

  return (
    <div className="op-page">
      <div className="tc-top">
        <span className="tc-title">Операторы</span>
        <span aria-hidden="true" className="tc-sep" />
        <div className="op-tabs" role="tablist" aria-label="Разделы">
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'inbox'}
            className={tab === 'inbox' ? 'op-tab is-on' : 'op-tab'}
            onClick={() => setTab('inbox')}
          >
            Запросы
            {waiting > 0 && <span className="v2-nav-count">{waiting}</span>}
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'setup'}
            className={tab === 'setup' ? 'op-tab is-on' : 'op-tab'}
            onClick={() => setTab('setup')}
          >
            Настройка
          </button>
        </div>
      </div>
      {tab === 'inbox' ? (
        <OperatorsInbox onOpenSetup={() => setTab('setup')} />
      ) : (
        <div className="op-setup-scroll">
          <OperatorsSetup />
        </div>
      )}
    </div>
  );
}
